import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceService } from 'src/app/device/shared/services/device.service';
import { WeatherDataItem } from 'src/app/device/shared/interfaces/weatherDataItem';
import { WeatherDataDisplayValue } from 'src/app/device/shared/interfaces/weatherData-display-value.interface';
import {
  getWeatherDataTime,
  getWeatherDataDetailDisplayValues
} from 'src/app/device/shared/functions/weatherData-display-values';

@Component({
  selector: 'avs-weatherData-details',
  templateUrl: './weatherData-details.component.html',
  styleUrls: ['./weatherData-details.component.css']
})
export class WeatherDataDetailsComponent {
  public guid?: string;
  public deviceName?: string;
  public displayValues: WeatherDataDisplayValue[] = [];
  public dataDataTime?: string;
  public isLoading: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private deviceService: DeviceService,
    private dialogRef: MatDialogRef<WeatherDataDetailsComponent>) { }

  public ngOnInit(): void {
    const routeStation = this.data.data.routeStation;
    this.guid = routeStation?.id;
    this.deviceName = routeStation?.name;
    if (!this.guid) {
      this.isLoading = false;
      return;
    }
    this.deviceService.getWeatherDataDetailsByGuid(this.guid).subscribe({
      next: (details: WeatherDataItem) => {
        this.displayValues = getWeatherDataDetailDisplayValues(details);
        this.dataDataTime = getWeatherDataTime(details);
        this.isLoading = false;
      },
      // Error messages are already shown by the HttpService.
      error: () => {
        this.displayValues = [];
        this.isLoading = false;
      }
    });
  }

  public onCloseClicked(): void {
    this.dialogRef.close();
  }
}
